import React from 'react';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var ChlSVG = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 36 36"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#1F429B",
  d: "M13 5H4a4 4 0 00-4 4v9h13V5zm-4.663 9.292l-1.882-1.367-1.882 1.367.719-2.212-1.882-1.368h2.326L6.455 8.5l.719 2.212H9.5L7.618 12.08l.719 2.212z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EEE",
  d: "M32 5H13v13h23V9a4 4 0 00-4-4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D42D27",
  d: "M0 18v9a4 4 0 004 4h28a4 4 0 004-4v-9H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M7.174 10.712L6.455 8.5l-.719 2.212H3.41l1.882 1.368-.719 2.212 1.882-1.367 1.882 1.367-.719-2.212L9.5 10.712z"
})));

export { ChlSVG as default };
//# sourceMappingURL=bundle.esm3.js.map
